<template>
  <div class="pa-2 pa-sm-4">
    <v-btn @click="$router.back()" class="back-btn mb-2">
      <v-icon left>mdi-arrow-left</v-icon>
      VOLVER
    </v-btn>

    <!-- Banner Informativo -->
    <v-alert
      dense
      prominent
      border="left"
      color="amber darken-2"
      dark
      class="rounded-lg elevation-2 mb-3 info-alert-banner"
      icon="mdi-alert-circle-outline"
    >
      <div class="text-subtitle-2 font-weight-bold mb-1 info-alert-title">
        Configuración de Remanente por Aplicación
      </div>
      <div class="text-body-2 info-alert-text">
        Ingrese los límites de remanente para que la aplicación esté disponible en el registro y edición de vehículos.
        Si la aplicación requerida no existe, puede registrarla rápidamente pulsando el botón <strong>"Nuevo"</strong>.
      </div>
    </v-alert>

    <v-col cols="12" class="pa-0">
      <tabla
        Titulo="Lista de Remanente por Aplicación"
        :Cabecera="Cabecera"
        :Items="Items"
        :ItemsAplicacion="ItemsAplicacion"
        :Excel="true"
        :Crear="true"
        :Loading="Loading"
      />
    </v-col>
  </div>
</template>

<script>
import tabla from "@/components/aplicacion/tabla.vue";
import { mapGetters, mapActions, mapState } from "vuex";

export default {
  name: "Aplicacion",
  components: {
    tabla,
  },
  data() {
    return {
      Cabecera: [
        {
          text: "Acciones",
          value: "acciones",
          align: "center",
          sortable: false,
          width: 90,
        },
        {
          text: "Aplicación",
          value: "aplicacion_nom",
          align: "left",
        },
        {
          text: "Inicio Reencauche",
          value: "ini_reencauche",
          align: "center",
          width: 150,
        },
        {
          text: "Límite Reencauche",
          value: "reencauche",
          align: "center",
          width: 150,
        },
        {
          text: "Inicio Próx. Reencauche",
          value: "ini_prox_reencauche",
          align: "center",
          width: 180,
        },
        {
          text: "Límite Próx. Reencauche",
          value: "prox_reencauche",
          align: "center",
          width: 180,
        },
      ],
    };
  },
  computed: {
    ...mapGetters("aplicacion", ["Items", "ItemsAplicacion"]),
    ...mapState("aplicacion", ["Loading"]),
  },
  methods: {
    ...mapActions("aplicacion", ["cargarAplicacion", "cargarAplicacionCMB"]),
  },
  created() {
    this.cargarAplicacion();
    this.cargarAplicacionCMB();
  },
};
</script>

<style scoped>
@media (max-width: 600px) {
  .info-alert-banner {
    padding: 8px 12px !important;
  }
  .info-alert-title {
    font-size: 0.84rem !important;
  }
  .info-alert-text {
    font-size: 0.78rem !important;
    line-height: 1.35;
  }
}
</style>
